export const REFLECTION_PROMPTS = [
  "Where in your body did you first feel safe enough to say yes?",
  "What began to move in you once pleasure was allowed to travel?",
  "Where did you feel your inner fire glow brightest these three weeks?",
  "What tenderness did your heart reveal as pleasure became devotion?",
  "What did your breath teach you about sustaining bliss?",
  "In a moment of stillness, what light did you notice cascading through you?",
  "When every pathway joined as one, what did your whole body say?",
  "What changed in you when pleasure no longer needed to rush to an end?",
  "What did you witness, or create, in the dreamlike space of this gate?",
  "Where does the echo of your pleasure still linger in you?",
  "When the boundaries softened, what did you feel yourself become part of?",
  "What purpose or devotion did you hear resonating through you?",
  "How will you live now, with pleasure woven into your every day?",
];
